import {createSvgIcon} from '@logistics-frontend/blocks/icons/utils'
import React from 'react'

export default createSvgIcon(
  <svg fill="none" height="40" viewBox="0 0 68 40" width="68" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7918_6558)">
      <path clipRule="evenodd" d="M62.1756 1.25H5.02852C2.85187 1.25 1.08734 3.48858 1.08734 6.25V33.75C1.08734 36.5114 2.85187 38.75 5.02852 38.75H62.1756C64.3522 38.75 66.1168 36.5114 66.1168 33.75V6.25C66.1168 3.48858 64.3522 1.25 62.1756 1.25ZM5.02852 0C2.30771 0 0.102051 2.79822 0.102051 6.25V33.75C0.102051 37.2018 2.30771 40 5.02852 40H62.1756C64.8964 40 67.1021 37.2018 67.1021 33.75V6.25C67.1021 2.79822 64.8964 0 62.1756 0H5.02852Z" fill="white" fillRule="evenodd"/>
      <path d="M6.80212 23.5294L52.745 23.5294L46.045 31.7646L52.745 31.7646L62.3164 19.9999L52.745 8.23524L46.045 8.23524L52.745 16.4705L6.80212 16.4705L6.80212 23.5294Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_7918_6558">
        <rect fill="white" height="40" transform="translate(0.102051)" width="67"/>
      </clipPath>
    </defs>
  </svg>,
  'logo',
  {viewBox: '0 0 67 40'},
)
